import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-service",
  "use": "icon-service-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-service\"><path d=\"M512 128c-141.376 0-256 114.624-256 256v256c0 70.72 57.28 128 128 128h64V640h-64v-64h85.333c23.564 0 42.667-19.103 42.667-42.667V384c0-23.564-19.103-42.667-42.667-42.667H352v-42.666c0-88.224 71.776-160 160-160s160 71.776 160 160v42.666H576c-23.563 0-42.666 19.103-42.666 42.667v192c0 23.564 19.103 42.667 42.666 42.667H640v128h64c70.72 0 128-57.28 128-128V384c0-141.376-114.624-256-256-256z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/service.svg
// module id = nCjf
// module chunks = 29